<template>
    <!-- eslint-disable vue/no-v-model-argument -->
    <div class="surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
        <!-- LOADER -->
        <loading v-model:active="loader.isLoading" :can-cancel="false" :is-full-page="true" color="#007680" :width="loader.loaderSize" :height="loader.loaderSize" :opacity="loader.opacity" />

        <!-- FORGOT PASSWORD -->
        <div class="grid justify-content-center p-2 lg:p-0" style="min-width: 60%">
            <div class="col-12 xl:col-6" style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, rgba(70, 150, 160, 0.7) 10%, rgba(70, 150, 160, 0) 30%)">
                <div class="h-full w-full m-0 py-7 px-4" style="border-radius: 53px; background: linear-gradient(180deg, var(--surface-50) 38.9%, var(--surface-0))">
                    <Button class="p-button-danger p-button-rounded p-button-text" icon="pi pi-times" style="top: -2rem !important" :aria-label="$t('accesibility.forgot-password.return')" @click="toggleLanding"></Button>
                    <div class="grid flex flex-column align-items-center">
                        <div class="flex justify-content-center align-items-center border-circle" style="width: 3.2rem; height: 3.2rem">
                            <img src="/images/Logo_139x158.svg" alt="Bemyvega logo" class="mb-5" style="width: 81px; height: 60px" aria-hidden="true" />
                        </div>
                        <h1 class="text-900 font-bold text-4xl lg:text-5xl mb-2">
                            {{ $t("endpoints.forgot-password.header") }}
                        </h1>
                    </div>

                    <!-- FORGOT PASSWORD FORM -->
                    <form class="p-fluid" aria-describedby="Introduce tus datos" @submit.prevent="handleSubmit(!v$.$invalid)">
                        <!-- EMAIL -->
                        <div class="field" :aria-label="$t('accesibility.forgot-password.email')">
                            <div class="p-float-label p-input-icon-right mt-5">
                                <i aria-hidden="true" class="pi pi-envelope" />
                                <InputText id="email" v-model="v$.email.$model" :class="{ 'p-invalid': v$.email.$invalid && submitted }" aria-describedby="email-error" class="p-inputtext-lg" />
                                <label for="email" :class="{ 'p-error': v$.email.$invalid && submitted }">{{ $t("endpoints.forgot-password.body.email") }}</label>
                            </div>
                            <span v-if="v$.email.$error && submitted">
                                <span v-for="(error, index) of v$.email.$errors" id="email-error" :key="index">
                                    <small class="p-error">{{ error.$message }}</small>
                                </span>
                            </span>
                            <small v-else-if="(v$.email.$invalid && submitted) || v$.email.$pending.$response" class="p-error">{{ v$.email.required.$message.replace("Value", "Email") }}</small>
                        </div>

                        <!-- SUBMIT -->
                        <Button :label="$t('endpoints.forgot-password.body.button')" class="w-full p-3 text-xl mt-1" style="background: #007680" type="submit" aria-describedby="Enviar email" :aria-label="$t('accesibility.forgot-password.send-email')"></Button>

                        <Dialog v-model:visible="displayEmailDialog" header=" " :breakpoints="{ '960px': '80vw' }" :style="{ width: '30vw' }" :modal="true">
                            <div v-if="success == true">
                                <div class="flex align-items-center flex-column pt-6 px-3">
                                    <i class="pi pi-check-circle" :style="{ fontSize: '5rem', color: 'var(--green-500)' }"></i>
                                    <h5>{{ $t("endpoints.forgot-password.dialog.success.status") }}</h5>
                                    <p :style="{ lineHeight: '2rem', textIndent: '1rem', padding: '0.8rem' }">
                                        {{ $t("endpoints.forgot-password.dialog.success.message") }} <b>{{ email }}</b>
                                    </p>
                                </div>
                            </div>
                            <div v-else>
                                <div class="flex align-items-center flex-column pt-6 px-3">
                                    <i class="pi pi-times-circle" :style="{ fontSize: '5rem', color: 'var(--orange-900)' }"></i>
                                    <h5>{{ $t("endpoints.forgot-password.dialog.error.status") }}</h5>
                                    <p :style="{ lineHeight: '2rem', textIndent: '1rem', padding: '0.8rem' }">
                                        <b>{{ email }}</b> {{ $t("endpoints.forgot-password.dialog.error.message") }}
                                    </p>
                                </div>
                            </div>
                        </Dialog>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { email, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { mapState } from "vuex";
import { getClientOS, getClientBrowser } from "../utils/utils";
import { RepositoryFactory } from "../repositories/RepositoryFactory";

const EmailsRepository = RepositoryFactory.get("emails");

export default {
    components: {
        Loading
    },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            email: "",
            submitted: false,
            displayEmailDialog: false,
            success: false
        };
    },
    validations() {
        return {
            email: {
                required,
                email
            }
        };
    },
    computed: {
        ...mapState(["loader"]),
        logoColor() {
            if (this.$appState.darkTheme) return "white";
            return "dark";
        }
    },
    created() {
        document.title = this.$t("accesibility.title.login");
    },

    methods: {
        async sendEmail() {
            const OS = getClientOS();
            const browser = getClientBrowser();
            let payload = {
                email: [this.email],
                body: {
                    os: OS,
                    browser: browser
                }
            };
            try {
                await EmailsRepository.forgotPassword(payload);
                this.success = true;
            } catch (error) {
                console.log(error);
                this.success = false;
            }
            this.displayEmailDialog = true;
        },
        handleSubmit(isFormValid) {
            this.submitted = true;

            if (!isFormValid) {
                return;
            }

            this.sendEmail();
        },
        toggleLanding() {
            this.$router.push("/");
        }
    }
};
</script>

<style scoped>
.pi-eye {
    transform: scale(1.6);
    margin-right: 1rem;
}

.pi-eye-slash {
    transform: scale(1.6);
    margin-right: 1rem;
}
</style>
